import React, { useState } from 'react';

import styled from 'styled-components';

import useCountryName from '@hooks/CachedLists/UseCountryName';

import CustomerDrawer from '@components/ContactDetails/CustomerDetails/Drawer/CustomerDrawer';
import { NwLinkButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    font-size: ${(props) => props.theme.FontSizeSm};

    .company-name {
        font-size: 18px;
        font-weight: bold;
        margin: 0.25rem 0 0 0;
    }

    .contact-info {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        margin: 0;
        gap: 1rem;
        .contact-icon {
            margin-top: 0.25rem;
        }
        .contact-detail {
            overflow-wrap: break-word;
        }

        //other from 1st have .5rem margin-top
        &:not(:first-child) {
            margin-top: 0.5rem;
        }
    }

    .client-info {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        .client-left {
            flex: 1 1 0;
        }
        .client-middle {
            flex: 1 1 0;
        }
        .client-right {
            margin-top: -2rem;
            flex: 1 1 0;
        }
    }
`;

const CreditNoteClientInfo = ({ creditNoteData }) => {
    const { BillingInfo } = creditNoteData;
    const [showContactDrawer, setShowContactDrawer] = useState(false);
    const BillingCountryName = useCountryName(BillingInfo.Country);

    const onShowContactDrawer = () => {
        setShowContactDrawer(true);
    };

    const onCloseContactDrawer = () => {
        setShowContactDrawer(false);
    };

    const AddressLine2 = () => {
        //compose address line 2 with zip code, city and state
        //add comma and space only if city and state are present
        let addressLine2 = '';
        if (BillingInfo.Zip) addressLine2 += BillingInfo.Zip;
        if (BillingInfo.Zip && (BillingInfo.City || BillingInfo.State)) addressLine2 += ' ';
        if (BillingInfo.City) addressLine2 += BillingInfo.City;
        if (BillingInfo.City && BillingInfo.State) addressLine2 += ', ';
        if (BillingInfo.State) addressLine2 += BillingInfo.State;
        return addressLine2;
    };

    return (
        <Wrapper>
            <div className="company-name">{BillingInfo.CompanyName}</div>
            <div className="client-info">
                <div className="client-left">
                    <div>{BillingInfo.Street}</div>
                    <div>{AddressLine2()}</div>
                    <div>{BillingCountryName}</div>
                    <NwLinkButton onClick={() => onShowContactDrawer()} label={`open contact preview`} />
                </div>
                <div className="client-middle">
                    <div>{`VAT # ${BillingInfo.VatNumber}`}</div>
                    <div>{`Billing Type: ${BillingInfo.InvoiceType}`}</div>
                    <div>{`Vat Code: ${BillingInfo.VatCode}`}</div>
                </div>
                <div className="client-right">
                    {(BillingInfo.ContactName || BillingInfo.ContactPhone || BillingInfo.ContactEmail) && (
                        <div className="contact-info">
                            <div className="contact-icon">
                                <NwIcon size="2x" icon={byPrefixAndName.fasl['address-book']} />
                            </div>
                            <div className="contact-detail">
                                <div>
                                    <strong>{BillingInfo.ContactName}</strong>
                                </div>
                                <div>{BillingInfo.ContactPhone}</div>
                                <div>{BillingInfo.ContactEmail}</div>
                            </div>
                        </div>
                    )}
                    {(BillingInfo.ContactName2 || BillingInfo.ContactPhone2 || BillingInfo.ContactEmail2) && (
                        <div className="contact-info">
                            <div className="contact-icon">
                                <NwIcon size="2x" icon={byPrefixAndName.fasl['address-book']} />
                            </div>
                            <div className="contact-detail">
                                <div>
                                    <strong>{BillingInfo.ContactName2}</strong>
                                </div>
                                <div>{BillingInfo.ContactPhone2}</div>
                                <div>{BillingInfo.ContactEmail2}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showContactDrawer && (
                <CustomerDrawer customerID={creditNoteData.ContactID} onClose={onCloseContactDrawer} />
            )}
        </Wrapper>
    );
};

export default CreditNoteClientInfo;
